import { watch } from '@vue/composition-api';
import Vue from 'vue';
export const gogoBackendStatus = Vue.observable({
    projectId: '',
    status: '',
    backendInfo: null,
    buildLog: [],
    dialog: {
        show: false,
        left: 0,
        top: 0,
        width: 350,
        height: 380,
    },
    reset(projectId, status, backendInfo) {
        this.projectId = projectId;
        this.status = status;
        this.backendInfo = backendInfo;
    },
});
new Vue({
    setup() {
        watch(() => `${gogoBackendStatus.status}-${gogoBackendStatus.backendInfo?.buildLogDate}`, (_1, _2, onCleanup) => {
            let stopped = false;
            let timer;
            let buildLogReader;
            onCleanup(() => {
                stopped = true;
                if (timer)
                    clearTimeout(timer);
                buildLogReader?.cancel().catch(() => { });
            });
            gogoBackendStatus.buildLog = [];
            const readBuildLogStreamOnce = (async () => {
                const { gogoBackendBuildAPI, projectAPI } = await import('../../backendAPI');
                const { projectId } = gogoBackendStatus;
                if (!projectId)
                    return false;
                const buildLogStream = await gogoBackendBuildAPI.getBuildLogStream(projectId, gogoBackendStatus.backendInfo?.buildLogDate || '');
                if (stopped)
                    return;
                const buildLog = [];
                const reader = buildLogStream.getReader();
                buildLogReader = reader;
                let lastItem;
                try {
                    while (!stopped) {
                        const { done, value } = await reader.read();
                        if (done)
                            break;
                        const item = JSON.parse(value);
                        lastItem = item;
                        buildLog.push(item);
                        // 服务端重连后返回全量日志，因此每次连接内累积后整体覆盖，避免重复追加。
                        gogoBackendStatus.buildLog = Object.freeze([...buildLog]);
                    }
                }
                finally {
                    if (buildLogReader === reader)
                        buildLogReader = undefined;
                    reader.releaseLock();
                }
                if (lastItem && lastItem.type !== 'log' && lastItem.type !== 'start' && lastItem.type !== 'heartbeat') {
                    // refetch status!
                    projectAPI.getProjectInfo();
                    return true;
                }
                return false;
            });
            if (gogoBackendStatus.status !== 'deploying') {
                readBuildLogStreamOnce();
                return;
            }
            const pollLoop = async () => {
                while (!stopped) {
                    try {
                        const finished = await readBuildLogStreamOnce();
                        if (finished)
                            return;
                    }
                    catch (error) {
                        if (error?.code !== -101) {
                            console.error('[xy-client] poll backend build log failed', error);
                        }
                    }
                    if (stopped)
                        return;
                    await new Promise((resolve) => {
                        timer = setTimeout(resolve, 500);
                    });
                }
            };
            pollLoop();
        }, { immediate: true });
    },
});
